import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import jalaali from "jalaali-js";
import { Col, Button, Row } from "react-bootstrap";
import _, { find, isNull } from "lodash";
import { useForm, Controller, FormProvider } from "react-hook-form";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import HistoryIcon from "@mui/icons-material/History";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import ChangesHistoryModal from "./components/ChangesHistoryModal";
import CreateReserveFormDate from "./components/CreateReserveFormDate";
import CreateAllDates from "./components/CreateAllDates";
import AddDescriptionModal from "../AmusementServiceReservationForm/components/AddDescriptionModal";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementTemplate from "../../../core/api/api.template";
import SwitchBox from "../_Components/SwitchBox";
import ApiAmusementCalendar from "../../../core/api/api.calendars";
import { tools } from "../../../core/utils/tools";
import { IconClipBoard, IconInfo } from "../../../assets/icons";
import { isMobile } from "react-device-detect";

const switchItems1 = [{ title: "فرم رزرو", color: "#06b463", value: "false" }, { title: "رویداد", color: "#6f73f5", value: "true" }]
const switchItems2 = [
  { title: "پیش فرض", color: "#2d5d9c", value: "true" },
  { title: "بازه تاریخی", color: "#d12297", value: "false" },
]

const AmusementServiceReservationForm = () => {
  const [services, setServices] = useState([]);
  const [reserveItems, setReserveItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [reserveItemGroups, setReserveItemGroups] = useState([]);
  const methods = useForm({ values: { isDefault: null, isEvent: "false", selectedService: undefined } });
  const [showModalAddDescription, setShowModalAddDescription] = useState(false);
  const [reserveDescriptions, setReserveDescriptions] = useState([]);
  const [events, setEvents] = useState([]);
  const [nameDate, setNameDate] = useState();
  const [formLoading, setFormLoading] = useState(false)
  const [reserveDetailTemplate, setReserveDetailTemplate] = useState({});
  const [modalNameDate, setModalNameDate] = useState("");
  const [showModalChangesHistory, setShowModalChangesHistory] = useState(false);
  const [periodDates, setPeriodDates] = useState({ startDate: "", endDate: "", allDates: [], newDates: [] });
  const [periodDatesFilters, setPeriodDatesFilters] = useState({
    allDays: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });
  const lastService = useRef()
  const lastDate = useRef()

  const serviceController = useRef()

  const patternDate = methods.watch("patternDate");
  const selectedService = methods.watch("selectedService");
  const filter_Saturday = methods.watch(`filter_Saturday`);
  const filter_Sunday = methods.watch(`filter_Sunday`);
  const filter_Monday = methods.watch(`filter_Monday`);
  const filter_Tuesday = methods.watch(`filter_Tuesday`);
  const filter_Wednesday = methods.watch(`filter_Wednesday`);
  const filter_Thursday = methods.watch(`filter_Thursday`);
  const filter_Friday = methods.watch(`filter_Friday`);
  // Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data)) {
          setServices(data);
        }
      } catch { }
    };
    fetchServices();
  }, []);
  const closeModalAddDescription = useCallback(() => setShowModalAddDescription(false), []);
  const toJalaali = (date) => {
    const jDate = jalaali.toJalaali(date);
    return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
  };
  useEffect(() => {
    const today = new Date();
    const thirtyDaysFromNow = new Date(today);
    thirtyDaysFromNow.setDate(today.getDate() + 30);

    const formattedToday = toJalaali(today);
    const formattedThirtyDaysFromNow = toJalaali(thirtyDaysFromNow);
    methods.setValue("patternDate", formattedToday);
    methods.setValue("dateTimeStart", formattedToday);
    methods.setValue("dateTimeEnd", formattedThirtyDaysFromNow);
  }, []);

  // جدا کردن ساعت و دقیقه از مقدار زمان
  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    return `${hours}: ${minutes}`;
  };

  const onSubmit = async (data) => {
    let patternDate = "";
    let datePatternDate = methods.getValues("patternDate");

    if (data.isDefault == "true") patternDate = "default"
    else if (data.isDefault == "false" && datePatternDate !== null && typeof datePatternDate === "object") {
      patternDate =
        datePatternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
        datePatternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
        datePatternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
    } else {
      patternDate = datePatternDate?.replaceAll("/", "");
    }
    if (data.isEvent == "false" && _.isNil(patternDate)) {
      await SwalMessage({
        title: "لطفا ابتدا تاریخ الگو را انتخاب نمایید",
        iSsuccess: false,
      });
    } else if (selectedService == undefined || _.isNull(selectedService)) {
      await SwalMessage({
        title: "لطفا ابتدا سرویس را انتخاب کنید",
        iSsuccess: false,
      });
    } else {
      if (data.isEvent == "true") {
        const dates = []
        periodDates.allDates.map((date) => {
          const nameDate = date.year + date.month + date.day;
          if (data[`d_${nameDate}`]) {
            dates.push(nameDate);
          }
        });

        if (!data.hallEventId) {
          await SwalMessage({
            title: "یک رویداد انتخاب شود",
            iSsuccess: false,
          });
          return;
        }
        else if (dates.length == 0) {
          await SwalMessage({
            title: "حداقل یک تاریخ باید انتخاب شود",
            iSsuccess: false,
          });
          return;
        }
        try {
          const response = await ApiAmusementTemplate.create({
            amusementServiceId: selectedService,
            hallEventId: data.hallEventId,
            dates,
          });
          if (response?.succeeded) {
            SwalMessage({
              title: "تغییرات با موفقیت اعمال شد.",
              iSsuccess: true,
            });
          } else {
            await SwalMessage({
              title: response?.message ? response?.message : "خطا در روند اجرای برنامه!",
              iSsuccess: false,
            });
          }
        } catch (error) {
          await SwalMessage({
            title: "خطا در روند اجرای برنامه!!",
            iSsuccess: false,
          });
        }
      }
      else {
        var patternAmusementReserveItems = {
          dDesId: data[`${patternDate}-${selectedService}-Des`]?.value, // DateDescriptionId
          dIA: data[`${patternDate}-${selectedService}-IA`] ?? false, // DateIsActive
          g: reserveItemGroups.map((group) => ({
            // reserveItemGroups
            gId: group.id ?? null, // groupId
            gID: data[`${patternDate}-${selectedService}-${group.id}-ID`] ?? false, // GroupIsDisplay
            gIA: data[`${patternDate}-${selectedService}-${group.id}-IA`] ?? false, // GroupIsActive
            gDesId: data[`${patternDate}-${selectedService}-${group.id}-Des`]?.value, // GroupDescriptionId
            i: reserveItems.map((item) => ({
              // reserveItems
              iId: item.id ?? null, // itemId
              iID: data[`${patternDate}-${selectedService}-${group.id}-${item.id}-ID`] ?? false, // ItemIsDisplay
              iIA: data[`${patternDate}-${selectedService}-${group.id}-${item.id}-IA`] ?? false, // ItemIsActive
              iC: data[`${patternDate}-${selectedService}-${group.id}-${item.id}-C`] ?? 0, // ItemCapacity
              iIDL: item.iIDL,
              /// <summary>
              /// برای تفریحات گروهی مثل لیزرتگ اگر برای امروزاین فیلد مثلا مقدار یک داشته باشه
              /// به محض اینکه یک سفارش براش ثبت بشه، این آیتم تفریح ظرفیت تکمیل میشه
              /// </summary>
              iMGC: data[`${patternDate}-${selectedService}-${group.id}-${item.id}-MGC`] ?? null, //MaxGroupCount
              iIFC: data[`${patternDate}-${selectedService}-${group.id}-${item.id}-IFC`] ?? false, // ItemIsFullCapacity
              iMinC: data[`${patternDate}-${selectedService}-${group.id}-${item.id}-MinC`] ?? 0, // MinimumReserveCountPerDay
            })),
          })),
        };
        const jsonAmusementReserveItems = JSON.stringify(patternAmusementReserveItems);
        const dates = []
        periodDates.allDates.map((date) => {
          const nameDate = date.year + date.month + date.day;
          if (data[`d_${nameDate}`]) {
            dates.push(nameDate);
          }
        });
        if (dates.length == 0 && data.isDefault != "true") {
          await SwalMessage({
            title: "حداقل یک تاریخ باید انتخاب شود",
            iSsuccess: false,
          });
          return;
        }
        try {
          const response = await ApiAmusementTemplate.create({
            amusementServiceId: selectedService,
            ReservationFormTemplateJson: jsonAmusementReserveItems,
            dates: data.isDefault != "true" ? dates : undefined,
            isDefault: data.isDefault == "true"
            // beOverwritten: false,
          });
          if (response?.succeeded) {
            let datePatternDate = methods.getValues("patternDate");
            let patternDate = "";
            if (datePatternDate !== null && typeof datePatternDate === "object") {
              patternDate =
                datePatternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
                datePatternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
                datePatternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
            } else {
              patternDate = datePatternDate?.replaceAll("/", "");
            }
            await getSelectedServiceData(patternDate);
            resetAllFormInputs();
            lastService.current = selectedService
            lastDate.current = patternDate
            SwalMessage({
              title: "تغییرات با موفقیت اعمال شد.",
              iSsuccess: true,
            });
          } else {
            await SwalMessage({
              title: response?.message ? response?.message : "خطا در روند اجرای برنامه!",
              iSsuccess: false,
            });
          }
        } catch (error) {
          await SwalMessage({
            title: "خطا در روند اجرای برنامه!!",
            iSsuccess: false,
          });
        }
      }
    }
  };
  const onSubmitViewItems = async (data) => {
    if (_.isUndefined(patternDate) || _.isUndefined(selectedService)) {
      SwalMessage({
        title: _.isUndefined(selectedService) ? " تفریح مورد نظر را انتخاب کنید." : "تاریخ الگو را انتخاب کنید ",
        iSsuccess: false,
        timer: 5000,
      });
    } else {
      let patternDate = "";
      if (data?.patternDate && typeof data.patternDate === "object") {
        patternDate =
          data.patternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
          data.patternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
          data.patternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
      } else {
        patternDate = data.patternDate.replaceAll("/", "");
      }
      await getSelectedServiceData(patternDate);
      const newDefaults = {};
      Object.keys(methods.getValues()).forEach((fieldName) => {
        if (fieldName.startsWith(patternDate)) {
          newDefaults[fieldName] = ""; // یا مقدار جدید دلخواهت
        }
      });
    }
  };

  const getSelectedServiceData = async (patternDatee) => {
    if (!!patternDate && !!selectedService) {
      const newController = new AbortController()
      serviceController.current = newController
      try {
        const serviceAllFields = (await ApiAmusementService.getServiceTemplatesAndEvents({ serviceId: selectedService }, { signal: serviceController.current?.signal })).data
        setTemplates(serviceAllFields.amusementServiceReserveFormTemplates)
        if (serviceController.current == newController) {
          const descriptionsObject = JSON.parse(serviceAllFields.reserveDetail_V2Descriptions);
          const formattedDescriptions = !_.isNil(descriptionsObject)
            ? descriptionsObject?.map((desc) => ({
              value: desc.id,
              label: desc.desc,
            }))
            : [];
          setReserveDescriptions(formattedDescriptions);
          if (typeof patternDate == "string") {
            const response = await ApiAmusementService.getDatesBetweenTwoDates({ startDate: patternDate.replaceAll("/", ""), endDate: patternDate.replaceAll("/", "") })
            const nameDate = `${response[0].year}` + `${response[0].month}` + `${response[0].day}`;

            if (response)
              setNameDate({ formattedDate: response[0].date, nameDate, persianDayOfWeek: response[0].persianDayOfWeek })
          }
          else {
            const nameDate = `${patternDate.year}` + `${patternDate.month.number.toString().padStart(2, "0")}` + `${patternDate.day.toString().padStart(2, "0")}`;
            setNameDate({ formattedDate: tools.DateFormat(patternDate), nameDate, persianDayOfWeek: patternDate.weekDay.shortName })
          }

          if (lastService.current != selectedService) {
            setReserveItems([]);
            setReserveItemGroups([]);
            const amusementServiceReserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(selectedService);
            if (!_.isEmpty(amusementServiceReserveItems)) {
              const activeItems = amusementServiceReserveItems.filter(a => a.isActive);
              setReserveItems(activeItems);
            }
            const itemGroupResponse = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(selectedService);
            if (!_.isEmpty(itemGroupResponse)) {
              const activeItemGroupResponse = itemGroupResponse.filter(a => a.isActive);
              setReserveItemGroups(activeItemGroupResponse);
            }
          }
          isDefaultSetter(serviceAllFields.amusementServiceReserveFormTemplates, patternDatee)

          setEvents(serviceAllFields.hallEvents)
        }

      } catch {

      }

    }
    else
      setReserveItemGroups([])
  };

  const isDefaultSetter = (templates, patternDatee, copyFromDefault) => {
    const isDefault = typeof copyFromDefault == "boolean" ? copyFromDefault : methods.watch("isDefault") == "true"
    const formatedRespose = templates?.map(item => ({ ...item, calendars: item?.amusementServiceReserveFormCalendars?.map(itemmm => itemmm.date) }))
    const foundedTemplate = formatedRespose?.find((item) => isDefault ? item?.isDefault : item?.calendars?.includes(+patternDatee))
    const reserveDetailObjectNew = JSON.parse(foundedTemplate?.reservationFormTemplateJson ?? "{}");
    const convertedObj = {}
    convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-IA`] = reserveDetailObjectNew.dIA
    convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-Des`] = find(reserveDescriptions, (function (obj) {
      return _.toString(obj.value) == reserveDetailObjectNew.dDesId;
    }) ?? null)

    reserveItemGroups.forEach(group => {
      const groupValue = reserveDetailObjectNew?.g?.find(gg => gg.gId == group.id)
      convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-ID`] = groupValue?.gID
      convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-IA`] = groupValue?.gIA
      convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-Des`] = find(reserveDescriptions, (function (obj) {
        return _.toString(obj.value) == groupValue?.gDesId;
      }) ?? null)
      reserveItems?.forEach(ii => {
        const itemValue = groupValue?.i.find(rt => rt.iId == ii.id)

        convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-${ii.id}-ID`] = itemValue?.iID
        convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-${ii.id}-IA`] = itemValue?.iIA
        convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-${ii.id}-C`] = itemValue?.iC ?? ii?.defaultReserveCountPerDay
        convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-${ii.id}-MinC`] = itemValue?.iMinC ?? ii?.minimumReserveCountPerDay
        convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-${ii.id}-MGC`] = itemValue?.iMGC
        convertedObj[`${copyFromDefault ? patternDatee : isDefault ? "default" : patternDatee}-${selectedService}-${group.id}-${ii.id}-IFC`] = itemValue?.iIFC ?? ii?.iIFC
      })
    })
    const oldValues = Object.fromEntries(
      Object.entries(methods.getValues()).filter(([key]) => !key.includes("-"))
    )
    setReserveDetailTemplate({ isDefault: copyFromDefault ? false : isDefault, json: reserveDetailObjectNew })
    methods.reset({
      ...oldValues,
      ...convertedObj
    })
  }

  const values = useMemo(() => methods.getValues(), [methods]); // تمام فیلدهای ثبت‌شده

  const showHistoryModal = async () => {
    setShowModalChangesHistory(true);
  };

  useEffect(() => {
    if (periodDates.startDate != "" && periodDates.endDate != "") {
      const fetch_GetDatesBetweenTwoDates = async () => {
        try {
          const AllPeroidDates = await ApiAmusementService.getDatesBetweenTwoDates({
            startDate: periodDates.startDate,
            endDate: periodDates.endDate,
          });
          const newDates = _.differenceBy(AllPeroidDates, periodDates.allDates, "date");
          setPeriodDates({ ...periodDates, allDates: AllPeroidDates, newDates: newDates });
        } catch (error) {
        }
      };
      fetch_GetDatesBetweenTwoDates();

      Object.keys(values).forEach((fieldName) => {
        if (fieldName.startsWith("d-")) {
          // methods.resetField(fieldName);
        }
      });
    }
  }, [periodDates.startDate, periodDates.endDate]);
  useEffect(() => {
    periodDates.newDates.map(function (date) {
      const nameDate = date.year + date.month + date.day;
      methods.resetField(`d_${nameDate}`);
    });
    periodDates.allDates.map(function (date) {
      const nameDate = date.year + date.month + date.day;
      if (date.persianDayOfWeek == "شنبه" && filter_Saturday) methods.setValue(`d_${nameDate}`, filter_Saturday);
      if (date.persianDayOfWeek == "یکشنبه" && filter_Sunday) methods.setValue(`d_${nameDate}`, filter_Sunday);
      if (date.persianDayOfWeek == "دوشنبه" && filter_Monday) methods.setValue(`d_${nameDate}`, filter_Monday);
      if (date.persianDayOfWeek == "سه شنبه" && filter_Tuesday) methods.setValue(`d_${nameDate}`, filter_Tuesday);
      if (date.persianDayOfWeek == "چهارشنبه" && filter_Wednesday) methods.setValue(`d_${nameDate}`, filter_Wednesday);
      if (date.persianDayOfWeek == "پنج شنبه" && filter_Thursday) methods.setValue(`d_${nameDate}`, filter_Thursday);
      if (date.persianDayOfWeek == "جمعه" && filter_Friday) methods.setValue(`d_${nameDate}`, filter_Friday);
    });
  }, [periodDates.allDates]);
  useEffect(() => {
    if (
      filter_Saturday &&
      filter_Sunday &&
      filter_Monday &&
      filter_Tuesday &&
      filter_Wednesday &&
      filter_Thursday &&
      filter_Friday
    ) {
      methods.setValue("filter_AllDays", true);
      setPeriodDatesFilters({ ...periodDatesFilters, allDays: true });
    }
    else {
      methods.setValue("filter_AllDays", false);
      setPeriodDatesFilters({ ...periodDatesFilters, allDays: false });
    }
    periodDates.allDates.map(function (date) {
      const nameDate = date.year + date.month + date.day;
      if (date.persianDayOfWeek == "شنبه" && !_.isNil(periodDatesFilters.saturday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.saturday);
      if (date.persianDayOfWeek == "یکشنبه" && !_.isNil(periodDatesFilters.sunday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.sunday);
      if (date.persianDayOfWeek == "دوشنبه" && !_.isNil(periodDatesFilters.monday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.monday);
      if (date.persianDayOfWeek == "سه شنبه" && !_.isNil(periodDatesFilters.tuesday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.tuesday);
      if (date.persianDayOfWeek == "چهارشنبه" && !_.isNil(periodDatesFilters.wednesday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.wednesday);
      if (date.persianDayOfWeek == "پنج شنبه" && !_.isNil(periodDatesFilters.thursday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.thursday);
      if (date.persianDayOfWeek == "جمعه" && !_.isNil(periodDatesFilters.friday))
        methods.setValue(`d_${nameDate}`, periodDatesFilters.friday);
    });
  }, [
    periodDatesFilters.saturday,
    periodDatesFilters.sunday,
    periodDatesFilters.monday,
    periodDatesFilters.tuesday,
    periodDatesFilters.wednesday,
    periodDatesFilters.thursday,
    periodDatesFilters.friday,
    periodDatesFilters.allDays,
  ]);

  const getDateFromDatePicket = (date) => {
    if (!!date?.year) {
      return (
        date.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
        date.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
        date.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false })
      );
    } else return null;
  };
  useEffect(() => {
    (async () => {
      serviceController.current?.abort()
      if (selectedService != 0) {
        setFormLoading(true)
        let datePatternDate = methods.getValues("patternDate");
        let patternDate = "";
        if (datePatternDate !== null && typeof datePatternDate === "object") {
          patternDate =
            datePatternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            datePatternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            datePatternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          patternDate = datePatternDate?.replaceAll("/", "");
        }
        await getSelectedServiceData(patternDate);
        resetAllFormInputs();
        lastService.current = selectedService
        lastDate.current = patternDate
        setFormLoading(false)
      }
      else
        methods.setValue("isDefault", null)
    })();
  }, [selectedService, patternDate]);
  useEffect(() => {
    (async () => {
      if (selectedService != 0) {
        let datePatternDate = methods.getValues("patternDate");
        let patternDate = "";
        if (datePatternDate !== null && typeof datePatternDate === "object") {
          patternDate =
            datePatternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            datePatternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            datePatternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          patternDate = datePatternDate?.replaceAll("/", "");
        }
        isDefaultSetter(templates, patternDate)
        resetAllFormInputs();
        lastDate.current = patternDate
      }
    })();
  }, [templates, methods.watch("isDefault")]);

  const resetAllFormInputs = () => {
    //Reset all date checked box field for show new default value
    methods.resetField(`${nameDate?.nameDate}-${selectedService}-IA`);
    methods.resetField(`${nameDate?.nameDate}-${selectedService}-ID`);
    methods.resetField(`${nameDate?.nameDate}-${selectedService}-Des`);

    methods.resetField(`default-${selectedService}-IA`);
    methods.resetField(`default-${selectedService}-ID`);
    methods.resetField(`default-${selectedService}-Des`);

    reserveItemGroups.forEach((group) => {
      methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-ID`);
      methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-IA`);
      methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-Des`);

      methods.resetField(`default-${selectedService}-${group.id}-ID`);
      methods.resetField(`default-${selectedService}-${group.id}-IA`);
      methods.resetField(`default-${selectedService}-${group.id}-Des`);

      reserveItems.forEach((item) => {
        methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-${item.id}-ID`);
        methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-${item.id}-IA`);
        methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-${item.id}-C`);
        // methods.resetField(`${nameDate}-${selectedService}-${group.id}-${item.id}-IFC`);
        methods.resetField(`${nameDate?.nameDate}-${selectedService}-${group.id}-${item.id}-MinC`);

        methods.resetField(`default-${selectedService}-${group.id}-${item.id}-ID`);
        methods.resetField(`default-${selectedService}-${group.id}-${item.id}-IA`);
        methods.resetField(`default-${selectedService}-${group.id}-${item.id}-C`);
        // methods.resetField(`default-${selectedService}-${group.id}-${item.id}-IFC`);
        methods.resetField(`default-${selectedService}-${group.id}-${item.id}-MinC`);
      });
    });
  };
  const deleteAmusementReserveDetail = async () => {
    if (selectedService) {
      const dates = []
      periodDates.allDates.map((date) => {
        const nameDate = date.year + date.month + date.day;
        if (methods.getValues(`d_${nameDate}`)) {
          dates.push(+nameDate);
        }
      });
      if (dates.length == 0) {
        await SwalMessage({
          title: "حداقل یک تاریخ باید انتخاب شود",
          iSsuccess: false,
        });
        return;
      }
      Swal.fire({
        title: "عملیات حذف فرم رزرو",
        text: "از حذف فرم رزرو اطمینان دارید؟",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "بله",
        denyButtonText: "خیر",
        cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap btn btn-secondary ",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusCancel: true
      }).then((result) => {
        if (result.isConfirmed) {
          // (async () => {
          try {
            const responsePromise = ApiAmusementTemplate.delete({ serviceId: selectedService, dates });
            responsePromise.then((response) => {
              if (response.succeeded == true) {
                SwalMessage({
                  title: response.message,
                  iSsuccess: true,
                });
                resetAllFormInputs();
                methods.handleSubmit(onSubmitViewItems)();
              }
            });
          } catch (error) {
          }
          //}
          //)
        }
      });
    } else {
      SwalMessage({ title: "ابتدا تفریح مورد نظر را انتخاب کنید.", iSsuccess: false });
    }
  };

  const deleteAmusementReserveDetailDefault = async () => {
    if (selectedService) {
      Swal.fire({
        title: "عملیات حذف فرم رزرو پیش فرض",
        text: "از حذف فرم رزرو پیش فرض اطمینان دارید؟",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "بله",
        denyButtonText: "خیر",
        cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap btn btn-secondary ",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusCancel: true
      }).then((result) => {
        if (result.isConfirmed) {
          // (async () => {
          try {
            const responsePromise = ApiAmusementTemplate.delete({ serviceId: selectedService });
            responsePromise.then((response) => {
              if (response.succeeded == true) {
                resetAllFormInputs();
                methods.handleSubmit(onSubmitViewItems)();
              }
              SwalMessage({
                title: response.message,
                iSsuccess: response.succeeded,
              });
            });
          } catch (error) {
          }
          //}
          //)
        }
      });
    } else {
      SwalMessage({ title: "ابتدا تفریح مورد نظر را انتخاب کنید.", iSsuccess: false });
    }
  };

  const deleteAmusementReserveDetailAll = useCallback(async () => {
    if (selectedService) {
      Swal.fire({
        title: "عملیات حذف کل فرم رزرو",
        text: "از حذف کل فرم رزرو اطمینان دارید؟",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "بله",
        denyButtonText: "خیر",
        cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap btn btn-secondary ",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusCancel: true
      }).then((result) => {
        if (result.isConfirmed) {
          // (async () => {
          try {
            const responsePromise = ApiAmusementTemplate.deleteAll({ serviceId: selectedService });
            responsePromise.then((response) => {
              if (response.succeeded == true) {
                resetAllFormInputs();
                methods.handleSubmit(onSubmitViewItems)();
              }
              SwalMessage({
                title: response.message,
                iSsuccess: response.succeeded,
              });
            });
          } catch (error) {
          }
          //}
          //)
        }
      })
    } else {
      SwalMessage({ title: "ابتدا تفریح مورد نظر را انتخاب کنید.", iSsuccess: false });
    }
  }, [selectedService]);

  const cancelEvent = async () => {
    const dates = []
    periodDates.allDates.map((date) => {
      const nameDate = date.year + date.month + date.day;
      if (methods.watch(`d_${nameDate}`)) {
        dates.push(tools.formatShamsiDate(nameDate));
      }
    });
    if (methods.watch("hallEventId")) {
      if (dates.length)
        Swal.fire({
          title: "عملیات لغو رویداد",
          text: "از لغو رویداد در تاریخ های مورد نظر اطمینان دارید؟",
          icon: "question",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "بله",
          denyButtonText: "خیر",
          cancelButtonText: "انصراف",
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap btn btn-secondary ",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        }).then((result) => {
          if (result.isConfirmed) {
            // (async () => {
            try {
              const responsePromise = ApiAmusementCalendar.changeStatusHallEventCalendars({ hallEventId: methods.watch("hallEventId"), dates });
              responsePromise.then((response) => {
                if (response.succeeded == true) {
                  resetAllFormInputs();
                  methods.handleSubmit(onSubmitViewItems)();
                }
                SwalMessage({
                  title: response.message,
                  iSsuccess: response.succeeded,
                });
              });
            } catch (error) {
            }
            //}
            //)
          }
        });
      else {
        await SwalMessage({
          title: "حداقل یک تاریخ باید انتخاب شود",
          iSsuccess: false,
        });
        return;
      }
    } else {
      SwalMessage({ title: "ابتدا رویداد مورد نظر را انتخاب کنید.", iSsuccess: false });
    }
  };

  return (
    <div className="card min-height mb-6">
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header d-flex justify-content-between align-items-center border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت فرم رزرو</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">فرم رزرو تفریح - زمان بندی رویداد</span>
          </h3>

        </div>
        <div className="card-body pt-0 px-4">
          <FormProvider {...methods}>
            <form noValidate autoComplete="off" className="mt-3" onSubmit={methods.handleSubmit(onSubmitViewItems)}>
              <Row className="mb-3 align-items-center">
                <Col xs="12" sm="4" md xl="4">
                  <Controller
                    name="selectedService"
                    control={methods.control}
                    render={({ field }) => (
                      <SelectComponent
                        name="service"
                        className="mt-5 w-100"
                        variant="outlined"
                        placeholder="انتخاب سرویس"
                        options={services?.map((item) => ({
                          value: item.id,
                          label: item.name,
                          type: "service",
                        }))}
                        noLabel
                        value={
                          services
                            .map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))
                            .find((option) => option.value === field.value) || null
                        }
                        onChange={(selectedOption) => {
                          if (!selectedOption?.value)
                            methods.setValue("isDefault", null)
                          field.onChange(selectedOption?.value ?? null);
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="4" md xl="4" className={`d-flex gap-2 mt-3 ${isMobile && "justify-content-center"}`}>
                  <div className="d-flex gap-2 mt-2 align-items-center flex-shrink-0">
                    <Controller
                      name="isEvent"
                      control={methods.control}
                      render={({ field: { onChange, value } }) => {
                        return (
                          <SwitchBox
                            items={switchItems1}
                            value={value}
                            onChange={onChange}
                            noShadow
                            noTransForm
                          />
                        );
                      }}
                    />
                  </div>
                </Col>
              </Row>
              {selectedService && <Row>
                {methods.watch("isEvent") == "false" &&
                  <>
                    <Col xs="12" sm="4" md xl="4">
                      <Controller
                        name="patternDate"
                        control={methods.control}
                        render={({ field: { onChange, value } }) => (
                          <ShamsiDatePicker
                            className="mt-5"
                            value={value}
                            onChange={onChange}
                            placeholder="انتخاب فرم الگو"
                          />
                        )}
                      />
                    </Col>
                    <Col xs="12" md="auto" className="mt-5 d-flex justify-content-center align-items-center">
                      <Controller
                        name="isDefault"
                        control={methods.control}
                        render={({ field: { onChange, value } }) => {
                          return (
                            <SwitchBox
                              items={switchItems2}
                              value={value}
                              onChange={(e) => {
                                if (!methods.watch("selectedService")) {
                                  SwalMessage({ iSsuccess: false, title: "ابتدا سرویس را انتخاب کنید" })
                                  return
                                }
                                onChange(e)
                              }}
                              noShadow
                              noTransForm
                            />
                          );
                        }}
                      />
                    </Col>
                    {methods.watch("isDefault") == "false" &&
                      <Col xs="6" md="auto" className="mt-5 d-flex justify-content-center align-items-center">
                        <Button
                          onClick={() => {
                            isDefaultSetter(templates, typeof patternDate == "object" ? patternDate?.year + patternDate.month.number.toString().padStart(2, "0") + patternDate.day.toString().padStart(2, "0") : patternDate.replaceAll("/", ""), true)
                          }}
                          type="button"
                          className="d-flex gap-2"
                        >
                          <IconClipBoard fillColor="white" />
                                کپی از پیش‌فرض
                              </Button>
                      </Col>}
                    <Col xs="6" md="auto" className="mt-5 d-flex justify-content-center align-items-center">
                      <Button variant="info" type="button" className="mx-2" color="success" onClick={showHistoryModal}>
                        <HistoryIcon className="mr-1" />
                                تاریخچه تغییرات
                              </Button>
                    </Col>
                    {methods.watch("selectedService") && methods.watch("isEvent") == "false" && <Col xs="6" md="auto" className="mt-5 d-flex justify-content-center align-items-center">

                      <Button variant="danger" type="button" className=" mx-2" onClick={deleteAmusementReserveDetailAll} >
                        <DeleteIcon className="mr-1" />
                      حذف کل فرم رزرو
                    </Button>

                    </Col>
                    }
                  </>
                }
                {methods.watch("isEvent") == "true" &&
                  <Col xs="12" sm="4" md xl="4" className="mt-5">
                    <Controller
                      name="hallEventId"
                      control={methods.control}
                      render={({ field }) => (
                        <SelectComponent
                          variant="outlined"
                          placeholder="انتخاب رویداد"
                          options={events?.map((item) => ({
                            value: item.id,
                            label: item.title,
                          }))}
                          noLabel
                          value={
                            events
                              .map((item) => ({
                                value: item.id,
                                label: item.title,
                              }))
                              .find((option) => option.value === field.value) || null
                          }
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption?.value ?? null);
                          }}
                        />
                      )}
                    />
                  </Col>
                }
              </Row>}
            </form>
            <form noValidate autoComplete="off" className="mt-3" onSubmit={methods.handleSubmit(onSubmit)}>
              <Row>
                <Col xs="12">
                  {!!reserveDetailTemplate.json && !!reserveItemGroups.length && !!reserveItems.length && methods.watch("isEvent") == "false" && typeof methods.watch("isDefault") == "string" &&
                    <div className="d-flex flex-column align-items-center gap-2 position-relative">
                      <CreateReserveFormDate
                        service={selectedService}
                        //set reserveDetail for past version
                        reserveDetail={reserveDetailTemplate}
                        reserveDescriptions={reserveDescriptions}
                        date={nameDate}
                        reserveItemGroups={reserveItemGroups}
                        reserveItems={reserveItems}
                        formatTime={formatTime}
                        setModalNameDate={setModalNameDate}
                        setShowModalAddDescription={setShowModalAddDescription}
                      />
                      {formLoading &&
                        <div
                          style={{
                            inset: 0,
                            backgroundColor: "rgba(255,255,255,0.9)",
                            fontSize: 16
                          }}
                          className="position-absolute fw-bold d-flex justify-content-center align-items-center" >
                          در حال بارگزاری...
                        </div>
                      }
                    </div>
                  }
                </Col>
                {selectedService && ((methods.watch("isDefault") == "false") || (methods.watch("isEvent") == "true" && !!methods.watch("hallEventId"))) &&
                  <Col xs="12">
                    <Row>
                      <Col xs="12" sm="auto" className="flex-grow-1">
                        <Controller
                          name="dateStart"
                          control={methods.control}
                          render={({ field: { onChange, value } }) => (
                            <ShamsiDatePicker
                              className="mt-5"
                              value={value}
                              onChange={(val) => {
                                onChange(val);
                                if (!val) {
                                  methods.setValue("dateEnd", null)
                                  setPeriodDates({ allDates: [], newDates: [], endDate: "", startDate: "" });
                                }
                                else if (getDateFromDatePicket(val) >= getDateFromDatePicket(methods.watch("dateEnd"))) {
                                  methods.setValue("dateEnd", null)
                                  setPeriodDates({ allDates: [], newDates: [], endDate: "", startDate: getDateFromDatePicket(val) });
                                }
                                else {
                                  setPeriodDates({ ...periodDates, startDate: getDateFromDatePicket(val) });
                                }
                              }}
                              min={new Date()}
                              placeholder="از تاریخ"
                            />
                          )}
                        />
                      </Col>
                      <Col xs="12" sm="auto" className="flex-grow-1">
                        <Controller
                          name="dateEnd"
                          control={methods.control}
                          render={({ field: { onChange, value } }) => {
                            return (
                              <ShamsiDatePicker
                                className="mt-5"
                                value={value}
                                onChange={(val) => {
                                  onChange(val);
                                  if (!val) {
                                    setPeriodDates({ ...periodDates, allDates: [], newDates: [], endDate: "" });
                                  } else
                                    setPeriodDates({ ...periodDates, endDate: getDateFromDatePicket(val) });
                                }}
                                min={methods.watch("dateStart") ?? new Date()}
                                currentDate={methods.watch("dateStart") ?? new Date()}
                                placeholder="تا تاریخ"
                              />
                            );
                          }}
                        />
                      </Col>
                      {methods.watch("isEvent") == "true" && <Col className="d-flex justify-content-end">
                        <Button variant="danger" type="button" className="mt-5 mx-2" onClick={cancelEvent} >
                          <DeleteIcon className="mr-1" />
                          لغو رویداد
                        </Button>
                      </Col>}
                      {methods.watch("selectedService") && methods.watch("isDefault") == "false" && methods.watch("isEvent") == "false" &&
                        <Col className="d-flex justify-content-end">
                          <Button variant="danger" type="button" className="mt-5 mx-2" onClick={deleteAmusementReserveDetail}>
                            <DeleteIcon className="mr-1" />
                             حذف فرم رزرو روزهای انتخابی
                          </Button>
                        </Col>
                      }
                    </Row>
                    <Row className="mb-3 mt-5 text-small">
                      <Col xs="3" md="auto" className="d-flex align-items-center">
                        <Controller
                          name="filter_AllDays"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              id="filter_AllDays"
                              checked={field.value ?? false}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters({
                                  ...periodDatesFilters,
                                  allDays: isChecked,
                                  saturday: isChecked,
                                  sunday: isChecked,
                                  monday: isChecked,
                                  tuesday: isChecked,
                                  wednesday: isChecked,
                                  thursday: isChecked,
                                  friday: isChecked,
                                });
                                methods.setValue(`filter_Saturday`, isChecked);
                                methods.setValue(`filter_Sunday`, isChecked);
                                methods.setValue(`filter_Monday`, isChecked);
                                methods.setValue(`filter_Tuesday`, isChecked);
                                methods.setValue(`filter_Wednesday`, isChecked);
                                methods.setValue(`filter_Thursday`, isChecked);
                                methods.setValue(`filter_Friday`, isChecked);
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_AllDays" className="user-select-none me-1" style={{ margin: 0 }}>همه روزها</label>
                      </Col>
                      <Col xs="3" md="auto" className="d-flex align-items-center">
                        <Controller
                          name="filter_Saturday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              id="filter_Saturday"
                              checked={field.value ?? false}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: isChecked,
                                  sunday: null,
                                  monday: null,
                                  tuesday: null,
                                  wednesday: null,
                                  thursday: null,
                                  friday: null,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Saturday" className="user-select-none me-1" style={{ margin: 0 }}>شنبه</label>
                      </Col>
                      <Col xs="3" md="auto" className=" d-flex align-items-center">
                        <Controller
                          name="filter_Sunday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              checked={field.value ?? false}
                              id="filter_Sunday"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: null,
                                  sunday: isChecked,
                                  monday: null,
                                  tuesday: null,
                                  wednesday: null,
                                  thursday: null,
                                  friday: null,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Sunday" className="user-select-none me-1" style={{ margin: 0 }}>یکشنبه</label>
                      </Col>
                      <Col xs="3" md="auto" className=" d-flex align-items-center">
                        <Controller
                          name="filter_Monday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              checked={field.value ?? false}
                              id="filter_Monday"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: null,
                                  sunday: null,
                                  monday: isChecked,
                                  tuesday: null,
                                  wednesday: null,
                                  thursday: null,
                                  friday: null,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Monday" className="user-select-none me-1" style={{ margin: 0 }}>دوشنبه</label>
                      </Col>
                      <Col xs="3" md="auto" className="d-flex align-items-center">
                        <Controller
                          name="filter_Tuesday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              checked={field.value ?? false}
                              id="filter_Tuesday"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: null,
                                  sunday: null,
                                  monday: null,
                                  tuesday: isChecked,
                                  wednesday: null,
                                  thursday: null,
                                  friday: null,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Tuesday" className="user-select-none me-1" style={{ margin: 0 }}>سه شنبه</label>
                      </Col>
                      <Col xs="3" md="auto" className=" d-flex align-items-center">
                        <Controller
                          name="filter_Wednesday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              id="filter_Wednesday"
                              name={field.name}
                              checked={field.value ?? false}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: null,
                                  sunday: null,
                                  monday: null,
                                  tuesday: null,
                                  wednesday: isChecked,
                                  thursday: null,
                                  friday: null,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Wednesday" className="user-select-none me-1" style={{ margin: 0 }}>چهارشنبه</label>
                      </Col>
                      <Col xs="3" md="auto" className=" d-flex align-items-center">
                        <Controller
                          name="filter_Thursday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              checked={field.value ?? false}
                              id="filter_Thursday"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: null,
                                  sunday: null,
                                  monday: null,
                                  tuesday: null,
                                  wednesday: null,
                                  thursday: isChecked,
                                  friday: null,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Thursday" className="user-select-none me-1" style={{ margin: 0 }}>پنجشنبه</label>
                      </Col>
                      <Col xs="3" md="auto" className=" d-flex align-items-center">
                        <Controller
                          name="filter_Friday"
                          control={methods.control}
                          render={({ field }) => (
                            <input
                              type="checkbox"
                              name={field.name}
                              id="filter_Friday"
                              checked={field.value ?? false}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                field.onChange(isChecked);
                                setPeriodDatesFilters((prev) => ({
                                  ...prev,
                                  saturday: null,
                                  sunday: null,
                                  monday: null,
                                  tuesday: null,
                                  wednesday: null,
                                  thursday: null,
                                  friday: isChecked,
                                }));
                              }}
                            />
                          )}
                        />
                        <label htmlFor="filter_Friday" className="user-select-none me-1" style={{ margin: 0 }}>جمعه</label>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col xs="12">
                        {periodDates?.allDates && periodDates.allDates.length != 0 && <CreateAllDates dates={periodDates.allDates} setPeriodDatesFilters={setPeriodDatesFilters} />}
                      </Col>
                    </Row>
                  </Col>}
              </Row>
              {selectedService && methods.watch("isEvent") == "false" && methods.watch("isDefault") == "true" && <Row className="px-5 my-3" style={{ width: "fit-content" }}>
                <div style={{ fontSize: 12, fontWeight: 800 }} className="d-flex gap-1 text-end bg-light-warning p-2 rounded-2 mt-2">
                  <div>
                    <IconInfo fillColor="#ffa800" />
                  </div>
                  لطفا دقت کنید!
                  <br />
                  در حالت پیش فرض بعد از اعمال تغییرات، فرم رزرو همه روز هایی که از فرم پیش فرض استفاده می‌کنند، تغییر خواهند کرد !
                </div>
              </Row>}
              <Row>
                <Col xs="12" sm="auto" className="text-md-center d-md-flex align-items-start mt-5">
                  {selectedService &&
                    ((methods.watch("isEvent") == "false" && typeof methods.watch("isDefault") == "string") ||
                      (methods.watch("isEvent") == "true" && !!methods.watch("hallEventId"))) &&
                    <Button disabled={!methods.watch("selectedService")} type="submit" color="primary">
                      <SaveIcon className="mr-1" />
                    ذخیره
                  </Button>}
                  {methods.watch("selectedService") && methods.watch("isDefault") == "true" && methods.watch("isEvent") == "false" &&
                    <Button variant="danger" type="button" className=" mx-2" onClick={deleteAmusementReserveDetailDefault} >
                      <DeleteIcon className="mr-1" />
                      حذف فرم رزرو پیش فرض
                    </Button>
                  }
                </Col>
              </Row>
            </form>
            {showModalAddDescription &&
              <AddDescriptionModal
                showModalAddDescription={showModalAddDescription}
                handleModalClose={closeModalAddDescription}
                modalNameDate={modalNameDate}
                setReserveDescriptions={setReserveDescriptions}
                service={selectedService}
                reserveDescriptions={reserveDescriptions}
                setShowModalAddDescription={setShowModalAddDescription}
              />}
          </FormProvider>
          {showModalChangesHistory && (
            <ChangesHistoryModal
              showModalChangesHistory={showModalChangesHistory}
              setShowModalChangesHistory={setShowModalChangesHistory}
              selectedServiceId={selectedService}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AmusementServiceReservationForm;
